import { FC } from 'react'
import { Input } from 'entities/Input'
import { TwoColumnedDiv } from 'entities/TwoColumnedDiv'
import { usePaymentConfigStore } from 'shared/store/paymentSlice'

export const SaferPay: FC = () => {
  const saferPay = usePaymentConfigStore().paymentConfig.saferPay
  const isConfigDataLoading = usePaymentConfigStore().isConfigDataLoading
  const updateSaferPayConfig = usePaymentConfigStore().updateSaferPayConfig

  const handleUpdate = (paramName: string, value: string) => {
    updateSaferPayConfig({ [paramName]: value })
  }

  return (
    // <TwoColumnedDiv>
    <TwoColumnedDiv key={`saferpay_input_${isConfigDataLoading}`}>
      {fieldsSaferPay.map(field => {
        return (
          <Input
            key={`saferPay_input-${field.value}-${saferPay?.[field.value as 'user']}`}
            label={field.label}
            type={field.type}
            autoComplete={field.type && 'new-password'}
            defaultValue={saferPay?.[field.value as 'user']}
            onBlur={e => handleUpdate(field.value, e)}
          />
        )
      })}
    </TwoColumnedDiv>
  )
}

const fieldsSaferPay = [
  {
    value: 'customerId',
    label: 'Customer ID'
  },
  {
    value: 'terminalId',
    label: 'Terminal ID'
  },
  {
    value: 'user',
    label: 'User'
  },
  {
    value: 'password',
    label: 'Password',
    type: 'password'
  }
]
